import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { MethodsCreate } from './MethodsCreate/MethodsCreate';
import { MethodsEdit } from './MethodsEdit/MethodsEdit';
import { MethodsList } from './MethodsList/MethodsList';
import { MethodsShow } from './MethodsShow/MethodsShow';

export const methodsResource: ResourceProps = {
  name: Resources.Methods,
  create: MethodsCreate,
  edit: MethodsEdit,
  list: MethodsList,
  show: MethodsShow,
};
